/** Lao text for property content: the editor in the booking engine and what guests see. */
export const laoHotelPropertyContent: Record<string, string> = {
  // Navigation and score
  'Property content': 'ຂໍ້ມູນທີ່ພັກ',
  'Property content sections': 'ພາກສ່ວນຂໍ້ມູນທີ່ພັກ',
  'Property content saved': 'ບັນທຶກຂໍ້ມູນທີ່ພັກແລ້ວ',
  'Property content score': 'ຄະແນນຂໍ້ມູນທີ່ພັກ',
  'Content score': 'ຄະແນນຂໍ້ມູນ',
  Complete: 'ຄົບຖ້ວນ',
  Excellent: 'ດີເລີດ',
  Good: 'ດີ',
  Fair: 'ພໍໃຊ້',
  'Needs work': 'ຕ້ອງປັບປຸງ',
  'Complete listings with great photos earn more trust and more direct bookings. Each improvement below raises your score.':
    'ຂໍ້ມູນທີ່ຄົບຖ້ວນ ພ້ອມຮູບງາມ ສ້າງຄວາມເຊື່ອໝັ້ນ ແລະ ເພີ່ມການຈອງໂດຍກົງ. ທຸກການປັບປຸງລຸ່ມນີ້ຊ່ວຍເພີ່ມຄະແນນຂອງທ່ານ.',
  'Your listing is ready to impress guests.': 'ຂໍ້ມູນທີ່ພັກຂອງທ່ານພ້ອມສ້າງຄວາມປະທັບໃຈໃຫ້ແຂກແລ້ວ.',
  'Add the missing details guests look for before they book.':
    'ເພີ່ມຂໍ້ມູນທີ່ຍັງຂາດ ທີ່ແຂກຊອກຫາກ່ອນຕັດສິນໃຈຈອງ.',
  'Guests compare photos, facilities and policies before they book. The booking page shows everything you add here.':
    'ແຂກປຽບທຽບຮູບ, ສິ່ງອຳນວຍຄວາມສະດວກ ແລະ ນະໂຍບາຍກ່ອນຈອງ. ໜ້າຈອງຈະສະແດງທຸກຢ່າງທີ່ທ່ານເພີ່ມຢູ່ນີ້.',
  'Top improvements': 'ສິ່ງທີ່ຄວນປັບປຸງກ່ອນ',
  Improve: 'ປັບປຸງ',
  'Every section is complete.': 'ທຸກພາກສ່ວນຄົບຖ້ວນແລ້ວ.',
  'Write a property description': 'ຂຽນຄຳອະທິບາຍທີ່ພັກ',
  'Add at least 3 highlights': 'ເພີ່ມຈຸດເດັ່ນຢ່າງໜ້ອຍ 3 ຂໍ້',
  'Set the property type and star rating': 'ກຳນົດປະເພດທີ່ພັກ ແລະ ລະດັບດາວ',
  'Upload at least 10 property photos': 'ອັບໂຫຼດຮູບທີ່ພັກຢ່າງໜ້ອຍ 10 ຮູບ',
  'Upload 3 photos of every room type': 'ອັບໂຫຼດ 3 ຮູບສຳລັບທຸກປະເພດຫ້ອງ',
  'Select at least 10 facilities': 'ເລືອກສິ່ງອຳນວຍຄວາມສະດວກຢ່າງໜ້ອຍ 10 ລາຍການ',
  'Describe every room type': 'ອະທິບາຍທຸກປະເພດຫ້ອງ',
  'Add bed types and room size': 'ເພີ່ມປະເພດຕຽງ ແລະ ຂະໜາດຫ້ອງ',
  'Select at least 5 amenities per room type':
    'ເລືອກສິ່ງອຳນວຍຄວາມສະດວກໃນຫ້ອງຢ່າງໜ້ອຍ 5 ລາຍການຕໍ່ປະເພດຫ້ອງ',
  'List the payment methods you accept': 'ລະບຸວິທີຊຳລະທີ່ທ່ານຮັບ',
  'Write your house rules': 'ຂຽນກົດລະບຽບຂອງທີ່ພັກ',
  'Add 3 nearby places': 'ເພີ່ມສະຖານທີ່ໃກ້ຄຽງ 3 ແຫ່ງ',
  'aim for': 'ເປົ້າໝາຍ',

  // Property details
  'The basics guests see first: what kind of place you are, your star rating and what makes you special.':
    'ຂໍ້ມູນພື້ນຖານທີ່ແຂກເຫັນກ່ອນ: ປະເພດທີ່ພັກ, ລະດັບດາວ ແລະ ຈຸດເດັ່ນຂອງທ່ານ.',
  'Property type': 'ປະເພດທີ່ພັກ',
  Hotel: 'ໂຮງແຮມ',
  Resort: 'ຣີສອດ',
  'Boutique hotel': 'ບູຕິກໂຮເທວ',
  Guesthouse: 'ເຮືອນພັກ',
  Hostel: 'ໂຮສເທວ',
  'Serviced apartment': 'ອາພາດເມັນພ້ອມບໍລິການ',
  Villa: 'ວິນລາ',
  Homestay: 'ໂຮມສະເຕ',
  Lodge: 'ລອດ',
  'Star rating': 'ລະດັບດາວ',
  star: 'ດາວ',
  stars: 'ດາວ',
  'Not rated': 'ບໍ່ມີລະດັບດາວ',
  'Use the official rating from your tourism authority, if you have one.':
    'ໃຊ້ລະດັບດາວທາງການຈາກໜ່ວຍງານທ່ອງທ່ຽວ ຖ້າທ່ານມີ.',
  'Year built': 'ປີທີ່ສ້າງ',
  'Last renovated': 'ປັບປຸງຫຼ້າສຸດ',
  Floors: 'ຈຳນວນຊັ້ນ',
  'Property description': 'ຄຳອະທິບາຍທີ່ພັກ',
  'Describe your location, the style of your rooms, your restaurant and what guests love about staying with you.':
    'ອະທິບາຍທີ່ຕັ້ງ, ຮູບແບບຫ້ອງພັກ, ຮ້ານອາຫານ ແລະ ສິ່ງທີ່ແຂກມັກເມື່ອມາພັກກັບທ່ານ.',
  Highlights: 'ຈຸດເດັ່ນ',
  'Short selling points shown as badges at the top of your booking page.':
    'ຈຸດຂາຍສັ້ນໆ ທີ່ສະແດງເປັນປ້າຍຢູ່ເທິງສຸດຂອງໜ້າຈອງ.',
  'Type a highlight and press Enter': 'ພິມຈຸດເດັ່ນ ແລ້ວກົດ Enter',
  Ideas: 'ຄຳແນະນຳ',
  'Free Wi-Fi': 'Wi-Fi ຟຣີ',
  'Free breakfast': 'ອາຫານເຊົ້າຟຣີ',
  'City center': 'ໃຈກາງເມືອງ',
  'Family friendly': 'ເໝາະສຳລັບຄອບຄົວ',
  'Swimming pool': 'ສະລອຍນ້ຳ',
  'Free parking': 'ບ່ອນຈອດລົດຟຣີ',
  'Languages your staff speak': 'ພາສາທີ່ພະນັກງານເວົ້າໄດ້',
  English: 'ອັງກິດ',
  Lao: 'ລາວ',
  Thai: 'ໄທ',
  Chinese: 'ຈີນ',
  Vietnamese: 'ຫວຽດນາມ',
  French: 'ຝຣັ່ງ',
  Korean: 'ເກົາຫຼີ',
  Japanese: 'ຍີ່ປຸ່ນ',
  German: 'ເຢຍລະມັນ',

  // Photos
  Photos: 'ຮູບພາບ',
  photo: 'ຮູບ',
  photos: 'ຮູບ',
  Photo: 'ຮູບ',
  'All photos': 'ຮູບທັງໝົດ',
  'Photo categories': 'ໝວດໝູ່ຮູບ',
  'Explore the property and rooms': 'ສຳຫຼວດທີ່ພັກ ແລະ ຫ້ອງພັກ',
  'Add new photos to': 'ເພີ່ມຮູບໃໝ່ໃສ່',
  'Show all photos to reorder.': 'ສະແດງຮູບທັງໝົດເພື່ອຈັດລຳດັບ.',
  'Upload photos for this category to help guests explore your property.':
    'ອັບໂຫຼດຮູບສຳລັບໝວດນີ້ ເພື່ອຊ່ວຍແຂກສຳຫຼວດທີ່ພັກຂອງທ່ານ.',
  'Great photos are the first thing guests judge. Upload bright, landscape photos of your property and every room type.':
    'ຮູບງາມຄືສິ່ງທຳອິດທີ່ແຂກໃຊ້ຕັດສິນ. ອັບໂຫຼດຮູບແນວນອນທີ່ສະຫວ່າງ ຂອງທີ່ພັກ ແລະ ທຸກປະເພດຫ້ອງ.',
  'Photo albums': 'ອະລະບັ້ມຮູບ',
  Property: 'ທີ່ພັກ',
  'Drag photos here or': 'ລາກຮູບມາວາງບ່ອນນີ້ ຫຼື',
  'browse your files': 'ເລືອກໄຟລ໌',
  'Adding to': 'ເພີ່ມໃສ່',
  'landscape, at least 1280 px wide. Large photos are resized for you.':
    'ແນວນອນ, ກວ້າງຢ່າງໜ້ອຍ 1280 px. ຮູບໃຫຍ່ຈະຖືກປັບຂະໜາດໃຫ້ອັດຕະໂນມັດ.',
  'low-resolution photos': 'ຮູບຄວາມລະອຽດຕ່ຳ',
  'Drag to reorder. The first photo is your cover.': 'ລາກເພື່ອຈັດລຳດັບ. ຮູບທຳອິດແມ່ນຮູບໜ້າປົກ.',
  'Drag to reorder. The first photo leads the room card.':
    'ລາກເພື່ອຈັດລຳດັບ. ຮູບທຳອິດຈະສະແດງຢູ່ບັດຫ້ອງ.',
  'Selected photos': 'ຮູບທີ່ເລືອກ',
  'Set category': 'ກຳນົດໝວດໝູ່',
  'Set category…': 'ກຳນົດໝວດໝູ່…',
  'Move to': 'ຍ້າຍໄປ',
  'Move to…': 'ຍ້າຍໄປ…',
  Delete: 'ລຶບ',
  Select: 'ເລືອກ',
  'Select photo': 'ເລືອກຮູບ',
  Cover: 'ໜ້າປົກ',
  'Low resolution': 'ຄວາມລະອຽດຕ່ຳ',
  Portrait: 'ແນວຕັ້ງ',
  'View photo': 'ເບິ່ງຮູບ',
  'Photo actions': 'ຈັດການຮູບ',
  'Set as cover photo': 'ຕັ້ງເປັນຮູບໜ້າປົກ',
  'Move earlier': 'ຍ້າຍໄປກ່ອນ',
  'Move later': 'ຍ້າຍໄປຫຼັງ',
  'Delete photo': 'ລຶບຮູບ',
  'Photo moved to': 'ຍ້າຍຮູບໄປ',
  Caption: 'ຄຳບັນຍາຍ',
  'Add a caption': 'ເພີ່ມຄຳບັນຍາຍ',
  'Optimizing…': 'ກຳລັງປັບຮູບ…',
  'No property photos yet': 'ຍັງບໍ່ມີຮູບທີ່ພັກ',
  'No photos yet': 'ຍັງບໍ່ມີຮູບ',
  'Show the bed, the bathroom and the view. Guests book rooms they can picture.':
    'ສະແດງຕຽງ, ຫ້ອງນ້ຳ ແລະ ວິວ. ແຂກຈອງຫ້ອງທີ່ເຂົາເຈົ້ານຶກພາບອອກ.',
  'Start with the exterior, the lobby, your restaurant and pool. The first photo becomes your cover.':
    'ເລີ່ມຈາກພາຍນອກອາຄານ, ລັອບບີ້, ຮ້ານອາຫານ ແລະ ສະລອຍນ້ຳ. ຮູບທຳອິດຈະເປັນຮູບໜ້າປົກ.',
  'Upload photos': 'ອັບໂຫຼດຮູບ',
  'Photo guidelines': 'ຄຳແນະນຳກ່ຽວກັບຮູບ',
  'Landscape photos at least 1280 × 720 pixels look sharp on every screen.':
    'ຮູບແນວນອນຂະໜາດຢ່າງໜ້ອຍ 1280 × 720 ພິກເຊວ ຈະຄົມຊັດໃນທຸກໜ້າຈໍ.',
  'Use daylight, tidy rooms and straight angles. Avoid filters, collages and watermarks.':
    'ໃຊ້ແສງທຳມະຊາດ, ຫ້ອງທີ່ຮຽບຮ້ອຍ ແລະ ມຸມກ້ອງຊື່. ຫຼີກລ່ຽງຟິວເຕີ, ຮູບຕັດຕໍ່ ແລະ ລາຍນ້ຳ.',
  'Only upload photos you own or have permission to use.':
    'ອັບໂຫຼດສະເພາະຮູບທີ່ທ່ານເປັນເຈົ້າຂອງ ຫຼື ໄດ້ຮັບອະນຸຍາດໃຫ້ໃຊ້.',
  'Location data in photos is removed before they are published.':
    'ຂໍ້ມູນສະຖານທີ່ໃນຮູບຈະຖືກລຶບອອກກ່ອນເຜີຍແຜ່.',
  'Delete this photo?': 'ລຶບຮູບນີ້ບໍ?',
  'Delete these photos?': 'ລຶບຮູບເຫຼົ່ານີ້ບໍ?',
  'Guests stop seeing it on your booking page right away. This cannot be undone.':
    'ແຂກຈະບໍ່ເຫັນຮູບນີ້ໃນໜ້າຈອງທັນທີ. ບໍ່ສາມາດຍົກເລີກໄດ້.',
  'Photo deleted': 'ລຶບຮູບແລ້ວ',
  'Choose a JPEG, PNG or WebP photo.': 'ເລືອກຮູບ JPEG, PNG ຫຼື WebP.',
  'A property can show up to': 'ທີ່ພັກສະແດງຮູບໄດ້ສູງສຸດ',
  'photos.': 'ຮູບ.',
  'Photos must be 3 MB or smaller.': 'ຮູບຕ້ອງມີຂະໜາດບໍ່ເກີນ 3 MB.',
  'This photo is too small. Use photos at least 1280 pixels wide.':
    'ຮູບນີ້ນ້ອຍເກີນໄປ. ໃຊ້ຮູບທີ່ກວ້າງຢ່າງໜ້ອຍ 1280 ພິກເຊວ.',
  'This photo could not be opened. Try another file.': 'ບໍ່ສາມາດເປີດຮູບນີ້ໄດ້. ລອງໄຟລ໌ອື່ນ.',
  'This photo could not be prepared. Try another file.': 'ບໍ່ສາມາດກະກຽມຮູບນີ້ໄດ້. ລອງໄຟລ໌ອື່ນ.',
  'The photos changed. Refresh and arrange them again.':
    'ຮູບມີການປ່ຽນແປງ. ໂຫຼດໃໝ່ ແລ້ວຈັດລຳດັບອີກຄັ້ງ.',
  'Photo not found': 'ບໍ່ພົບຮູບ',
  Exterior: 'ພາຍນອກອາຄານ',
  Interior: 'ພາຍໃນອາຄານ',
  'Lobby & reception': 'ລັອບບີ້ ແລະ ແຜນຕ້ອນຮັບ',
  Bathroom: 'ຫ້ອງນ້ຳ',
  'Restaurant & bar': 'ຮ້ານອາຫານ ແລະ ບາ',
  Pool: 'ສະລອຍນ້ຳ',
  'Spa & fitness': 'ສະປາ ແລະ ຟິດເນັສ',
  Facilities: 'ສິ່ງອຳນວຍຄວາມສະດວກ',
  Amenities: 'ເຄື່ອງອຳນວຍຄວາມສະດວກ',
  View: 'ວິວ',
  Surroundings: 'ບໍລິເວນອ້ອມຂ້າງ',

  // Facilities
  'Tick everything your property offers. Mark services that cost extra so guests know before they arrive.':
    'ໝາຍທຸກຢ່າງທີ່ທີ່ພັກຂອງທ່ານມີ. ລະບຸບໍລິການທີ່ມີຄ່າໃຊ້ຈ່າຍເພີ່ມ ເພື່ອໃຫ້ແຂກຮູ້ກ່ອນມາເຖິງ.',
  'Search facilities': 'ຊອກຫາສິ່ງອຳນວຍຄວາມສະດວກ',
  'No facilities match your search.': 'ບໍ່ພົບສິ່ງອຳນວຍຄວາມສະດວກທີ່ກົງກັບການຊອກຫາ.',
  Charge: 'ຄ່າບໍລິການ',
  'Extra charge': 'ມີຄ່າໃຊ້ຈ່າຍ',
  'General & front desk': 'ທົ່ວໄປ ແລະ ແຜນຕ້ອນຮັບ',
  '24-hour front desk': 'ແຜນຕ້ອນຮັບ 24 ຊົ່ວໂມງ',
  'Wi-Fi in public areas': 'Wi-Fi ໃນພື້ນທີ່ສ່ວນກາງ',
  'Air conditioning in public areas': 'ແອໃນພື້ນທີ່ສ່ວນກາງ',
  Elevator: 'ລິບ',
  'Non-smoking property': 'ທີ່ພັກປອດຢາສູບ',
  'Luggage storage': 'ບ່ອນຝາກກະເປົາ',
  'Safe deposit box at front desk': 'ຕູ້ນິລະໄພຢູ່ແຜນຕ້ອນຮັບ',
  'Daily housekeeping': 'ທຳຄວາມສະອາດປະຈຳວັນ',
  'Laundry service': 'ບໍລິການຊັກລີດ',
  Concierge: 'ບໍລິການຄອນເຊີຈ',
  'Currency exchange': 'ແລກປ່ຽນເງິນ',
  'Express check-in and check-out': 'ເຊັກອິນ ແລະ ເຊັກເອົາດ່ວນ',
  'Parking & transport': 'ບ່ອນຈອດລົດ ແລະ ການເດີນທາງ',
  Parking: 'ບ່ອນຈອດລົດ',
  'Shuttle service': 'ລົດຮັບສົ່ງ',
  'Car rental': 'ເຊົ່າລົດ',
  'Bicycle rental': 'ເຊົ່າລົດຖີບ',
  'Motorbike rental': 'ເຊົ່າລົດຈັກ',
  'Electric vehicle charging': 'ສາກລົດໄຟຟ້າ',
  'Food & drink': 'ອາຫານ ແລະ ເຄື່ອງດື່ມ',
  Restaurant: 'ຮ້ານອາຫານ',
  Bar: 'ບາ',
  Breakfast: 'ອາຫານເຊົ້າ',
  'Room service': 'ບໍລິການອາຫານໃນຫ້ອງ',
  'Coffee shop': 'ຮ້ານກາເຟ',
  'BBQ facilities': 'ບ່ອນປີ້ງບາບີຄິວ',
  Minimarket: 'ມິນິມາດ',
  'Vegetarian options': 'ອາຫານເຈ/ມັງສະວິລັດ',
  'Wellness & leisure': 'ສຸຂະພາບ ແລະ ພັກຜ່ອນ',
  'Outdoor pool': 'ສະລອຍນ້ຳກາງແຈ້ງ',
  'Indoor pool': 'ສະລອຍນ້ຳໃນຮົ່ມ',
  'Fitness center': 'ຫ້ອງອອກກຳລັງກາຍ',
  Spa: 'ສະປາ',
  Massage: 'ນວດ',
  Sauna: 'ຊາວໜ້າ',
  Garden: 'ສວນ',
  Terrace: 'ລະບຽງ',
  'Tour desk': 'ເຄົາເຕີທ່ອງທ່ຽວ',
  Karaoke: 'ຄາຣາໂອເກະ',
  'Business & events': 'ທຸລະກິດ ແລະ ງານກິດຈະກຳ',
  'Meeting rooms': 'ຫ້ອງປະຊຸມ',
  'Business center': 'ສູນທຸລະກິດ',
  'Banquet facilities': 'ຫ້ອງຈັດລ້ຽງ',
  'Printing and photocopying': 'ພິມ ແລະ ສຳເນົາເອກະສານ',
  Family: 'ຄອບຄົວ',
  'Family rooms': 'ຫ້ອງຄອບຄົວ',
  'Kids club': 'ຄລັບເດັກນ້ອຍ',
  Playground: 'ສະໜາມເດັກຫຼິ້ນ',
  Babysitting: 'ບໍລິການລ້ຽງເດັກ',
  'Children’s pool': 'ສະລອຍນ້ຳເດັກ',
  Accessibility: 'ການເຂົ້າເຖິງສຳລັບຄົນພິການ',
  'Wheelchair accessible': 'ລໍ້ເຂັນເຂົ້າເຖິງໄດ້',
  'Accessible parking': 'ບ່ອນຈອດລົດສຳລັບຄົນພິການ',
  'Accessible bathroom': 'ຫ້ອງນ້ຳສຳລັບຄົນພິການ',
  'Step-free entrance': 'ທາງເຂົ້າບໍ່ມີຂັ້ນໄດ',
  'Safety & cleanliness': 'ຄວາມປອດໄພ ແລະ ຄວາມສະອາດ',
  'CCTV in common areas': 'ກ້ອງວົງຈອນປິດໃນພື້ນທີ່ສ່ວນກາງ',
  '24-hour security': 'ພະນັກງານຮັກສາຄວາມປອດໄພ 24 ຊົ່ວໂມງ',
  'Smoke detectors': 'ເຄື່ອງກວດຈັບຄວັນ',
  'Fire extinguishers': 'ຖັງດັບເພີງ',
  'First aid kit': 'ຊຸດປະຖົມພະຍາບານ',
  'Contactless check-in': 'ເຊັກອິນແບບບໍ່ສຳຜັດ',
  'Regular sanitizing of common areas': 'ຂ້າເຊື້ອພື້ນທີ່ສ່ວນກາງເປັນປະຈຳ',

  // Room types
  'Room types': 'ປະເພດຫ້ອງ',
  'Describe each room type guests can book.': 'ອະທິບາຍແຕ່ລະປະເພດຫ້ອງທີ່ແຂກຈອງໄດ້.',
  'Guests compare rooms by size, beds, view and amenities. Complete every room type to help them choose.':
    'ແຂກປຽບທຽບຫ້ອງຕາມຂະໜາດ, ຕຽງ, ວິວ ແລະ ສິ່ງອຳນວຍຄວາມສະດວກ. ຕື່ມຂໍ້ມູນທຸກປະເພດຫ້ອງເພື່ອຊ່ວຍແຂກເລືອກ.',
  'No room types yet': 'ຍັງບໍ່ມີປະເພດຫ້ອງ',
  'Add rooms in Hotel settings first. Each room type then gets its own details here.':
    'ເພີ່ມຫ້ອງໃນການຕັ້ງຄ່າໂຮງແຮມກ່ອນ. ຈາກນັ້ນແຕ່ລະປະເພດຫ້ອງຈະມີລາຍລະອຽດຂອງຕົນເອງຢູ່ນີ້.',
  Size: 'ຂະໜາດ',
  Beds: 'ຕຽງ',
  '5+ amenities': 'ສິ່ງອຳນວຍຄວາມສະດວກ 5+',
  'Add photos': 'ເພີ່ມຮູບ',
  'Manage photos': 'ຈັດການຮູບ',
  'Room description': 'ຄຳອະທິບາຍຫ້ອງ',
  'What makes this room comfortable? Mention the layout, the bathroom and the view.':
    'ຫ້ອງນີ້ສະດວກສະບາຍແນວໃດ? ກ່າວເຖິງການຈັດວາງ, ຫ້ອງນ້ຳ ແລະ ວິວ.',
  'Room size (m²)': 'ຂະໜາດຫ້ອງ (ມ²)',
  'Bed type': 'ປະເພດຕຽງ',
  'Fewer beds': 'ຫຼຸດຕຽງ',
  'More beds': 'ເພີ່ມຕຽງ',
  'Remove bed type': 'ລຶບປະເພດຕຽງ',
  'Add a bed type': 'ເພີ່ມປະເພດຕຽງ',
  'King bed': 'ຕຽງຄິງ',
  'Queen bed': 'ຕຽງຄວີນ',
  'Double bed': 'ຕຽງຄູ່',
  'Single bed': 'ຕຽງດ່ຽວ',
  'Bunk bed': 'ຕຽງສອງຊັ້ນ',
  'Sofa bed': 'ໂຊຟາເບດ',
  Futon: 'ຟູກ',
  'No particular view': 'ບໍ່ມີວິວສະເພາະ',
  'City view': 'ວິວເມືອງ',
  'River view': 'ວິວແມ່ນ້ຳ',
  'Mountain view': 'ວິວພູເຂົາ',
  'Garden view': 'ວິວສວນ',
  'Pool view': 'ວິວສະລອຍນ້ຳ',
  'Lake view': 'ວິວທະເລສາບ',
  'Courtyard view': 'ວິວລານບ້ານ',
  'Smoking allowed in this room': 'ອະນຸຍາດໃຫ້ສູບຢາໃນຫ້ອງນີ້',
  'Most guests prefer non-smoking rooms. Leave this off unless guests may smoke inside.':
    'ແຂກສ່ວນຫຼາຍມັກຫ້ອງປອດຢາສູບ. ປິດໄວ້ ເວັ້ນເສຍແຕ່ແຂກສູບຢາໃນຫ້ອງໄດ້.',
  'Room amenities': 'ສິ່ງອຳນວຍຄວາມສະດວກໃນຫ້ອງ',
  Comfort: 'ຄວາມສະດວກສະບາຍ',
  'Air conditioning': 'ແອ',
  Fan: 'ພັດລົມ',
  Heating: 'ເຄື່ອງເຮັດຄວາມອຸ່ນ',
  'Blackout curtains': 'ຜ້າມ່ານກັນແສງ',
  Soundproofing: 'ກັນສຽງ',
  Wardrobe: 'ຕູ້ເສື້ອຜ້າ',
  'Work desk': 'ໂຕະເຮັດວຽກ',
  'Seating area': 'ບ່ອນນັ່ງ',
  Balcony: 'ລະບຽງ',
  'Private terrace': 'ລະບຽງສ່ວນຕົວ',
  'Private bathroom': 'ຫ້ອງນ້ຳສ່ວນຕົວ',
  Shower: 'ຝັກບົວ',
  Bathtub: 'ອ່າງອາບນ້ຳ',
  'Hot water': 'ນ້ຳອຸ່ນ',
  'Hair dryer': 'ເຄື່ອງເປົ່າຜົມ',
  'Free toiletries': 'ເຄື່ອງໃຊ້ໃນຫ້ອງນ້ຳຟຣີ',
  Bathrobe: 'ເສື້ອຄຸມອາບນ້ຳ',
  Slippers: 'ເກີບແຕະ',
  Towels: 'ຜ້າເຊັດໂຕ',
  'Media & technology': 'ສື່ ແລະ ເທັກໂນໂລຢີ',
  'Flat-screen TV': 'ໂທລະທັດຈໍແບນ',
  'Satellite or cable channels': 'ຊ່ອງດາວທຽມ ຫຼື ເຄເບິ້ນ',
  'Streaming services': 'ບໍລິການສະຕຣີມມິງ',
  Telephone: 'ໂທລະສັບ',
  'USB charging ports': 'ຊ່ອງສາກ USB',
  Minibar: 'ມິນິບາ',
  Refrigerator: 'ຕູ້ເຢັນ',
  'Electric kettle': 'ກາຕົ້ມນ້ຳໄຟຟ້າ',
  'Coffee and tea maker': 'ອຸປະກອນຊົງກາເຟ ແລະ ຊາ',
  'Free bottled water': 'ນ້ຳດື່ມຟຣີ',
  Kitchenette: 'ຄົວນ້ອຍ',
  Microwave: 'ໄມໂຄເວບ',
  'Dining table': 'ໂຕະກິນເຂົ້າ',
  'Services & safety': 'ບໍລິການ ແລະ ຄວາມປອດໄພ',
  'In-room safe': 'ຕູ້ນິລະໄພໃນຫ້ອງ',
  'Iron and ironing board': 'ເຕົາລີດ ແລະ ໂຕະລີດ',
  'Wake-up service': 'ບໍລິການປຸກ',
  'Mosquito net': 'ມຸ້ງ',
  'Smoke detector': 'ເຄື່ອງກວດຈັບຄວັນ',
  room: 'ຫ້ອງ',

  // Policies
  Policies: 'ນະໂຍບາຍ',
  'Clear rules prevent surprises at check-in. Guests read them on the booking page before they pay.':
    'ກົດລະບຽບທີ່ຊັດເຈນຊ່ວຍຫຼີກລ່ຽງບັນຫາຕອນເຊັກອິນ. ແຂກອ່ານໄດ້ໃນໜ້າຈອງກ່ອນຊຳລະ.',
  'Check-in and check-out': 'ເຊັກອິນ ແລະ ເຊັກເອົາ',
  'Check-in from': 'ເຊັກອິນຕັ້ງແຕ່',
  'Check-out until': 'ເຊັກເອົາກ່ອນ',
  'Change in Hotel settings': 'ປ່ຽນໃນການຕັ້ງຄ່າໂຮງແຮມ',
  'Latest check-in': 'ເຊັກອິນຊ້າສຸດ',
  'Leave empty if guests can arrive any time.': 'ປ່ອຍວ່າງໄວ້ ຖ້າແຂກມາເຖິງໄດ້ທຸກເວລາ.',
  'Minimum check-in age': 'ອາຍຸຕ່ຳສຸດໃນການເຊັກອິນ',
  'Early check-in': 'ເຊັກອິນກ່ອນເວລາ',
  'Late check-out': 'ເຊັກເອົາຊ້າ',
  'Not available': 'ບໍ່ມີ',
  'On request': 'ຕາມການຮ້ອງຂໍ',
  'Children and extra beds': 'ເດັກນ້ອຍ ແລະ ຕຽງເສີມ',
  'Children are welcome': 'ຍິນດີຕ້ອນຮັບເດັກນ້ອຍ',
  'Turn off for an adults-only property.': 'ປິດໄວ້ ຖ້າເປັນທີ່ພັກສຳລັບຜູ້ໃຫຍ່ເທົ່ານັ້ນ.',
  'Children stay free under age': 'ເດັກພັກຟຣີ ເມື່ອອາຍຸຕ່ຳກວ່າ',
  'Using existing beds. 0 means no free stays.': 'ໃຊ້ຕຽງທີ່ມີຢູ່. 0 ໝາຍເຖິງບໍ່ມີການພັກຟຣີ.',
  'Extra beds available': 'ມີຕຽງເສີມ',
  'Guests can ask for an extra bed in rooms that fit one.':
    'ແຂກຂໍຕຽງເສີມໄດ້ ໃນຫ້ອງທີ່ວາງຕຽງເສີມໄດ້.',
  'Extra bed fee per night': 'ຄ່າຕຽງເສີມຕໍ່ຄືນ',
  '0 when extra beds are free.': '0 ຖ້າຕຽງເສີມຟຣີ.',
  'Cribs available': 'ມີຕຽງເດັກອ່ອນ',
  'Baby cots on request.': 'ຕຽງເດັກອ່ອນຕາມການຮ້ອງຂໍ.',
  'Pets and smoking': 'ສັດລ້ຽງ ແລະ ການສູບຢາ',
  Pets: 'ສັດລ້ຽງ',
  Smoking: 'ການສູບຢາ',
  'Not allowed': 'ບໍ່ອະນຸຍາດ',
  'Designated areas': 'ພື້ນທີ່ທີ່ກຳນົດ',
  'Payments and ID': 'ການຊຳລະ ແລະ ບັດປະຈຳຕົວ',
  'Accepted payment methods': 'ວິທີຊຳລະທີ່ຮັບ',
  Cash: 'ເງິນສົດ',
  Visa: 'Visa',
  Mastercard: 'Mastercard',
  UnionPay: 'UnionPay',
  JCB: 'JCB',
  'American Express': 'American Express',
  'Bank transfer': 'ໂອນຜ່ານທະນາຄານ',
  'LAPNet / BCEL One QR': 'LAPNet / BCEL One QR',
  Alipay: 'Alipay',
  'WeChat Pay': 'WeChat Pay',
  'Deposit or prepayment note': 'ໝາຍເຫດເງິນມັດຈຳ ຫຼື ຊຳລະລ່ວງໜ້າ',
  'For example: a 50% deposit is charged after booking.': 'ຕົວຢ່າງ: ເກັບເງິນມັດຈຳ 50% ຫຼັງຈອງ.',
  'Passport or ID required at check-in': 'ຕ້ອງໃຊ້ໜັງສືຜ່ານແດນ ຫຼື ບັດປະຈຳຕົວຕອນເຊັກອິນ',
  'Lao law requires hotels to register guests with an official ID.':
    'ກົດໝາຍລາວກຳນົດໃຫ້ໂຮງແຮມລົງທະບຽນແຂກດ້ວຍເອກະສານທາງການ.',
  'House rules': 'ກົດລະບຽບຂອງທີ່ພັກ',
  'Quiet hours, visitors, parties, durian and anything else guests should know.':
    'ເວລາງຽບ, ແຂກມາຢ້ຽມ, ງານລ້ຽງ, ໝາກທຸລຽນ ແລະ ສິ່ງອື່ນໆທີ່ແຂກຄວນຮູ້.',

  // Location
  'Help guests picture where you are: the airport, sights, markets and how to find you.':
    'ຊ່ວຍໃຫ້ແຂກນຶກພາບທີ່ຕັ້ງຂອງທ່ານ: ສະໜາມບິນ, ສະຖານທີ່ທ່ອງທ່ຽວ, ຕະຫຼາດ ແລະ ວິທີມາຫາທ່ານ.',
  'Property address': 'ທີ່ຢູ່ທີ່ພັກ',
  'No address yet': 'ຍັງບໍ່ມີທີ່ຢູ່',
  'Add address': 'ເພີ່ມທີ່ຢູ່',
  'What’s nearby': 'ສະຖານທີ່ໃກ້ຄຽງ',
  Place: 'ສະຖານທີ່',
  'Distance (km)': 'ໄລຍະທາງ (ກມ)',
  'Wattay International Airport': 'ສະໜາມບິນສາກົນວັດໄຕ',
  'Add a place': 'ເພີ່ມສະຖານທີ່',
  'Guests see places sorted by distance, for example': 'ແຂກເຫັນສະຖານທີ່ຮຽງຕາມໄລຍະທາງ, ຕົວຢ່າງ',
  Directions: 'ວິທີເດີນທາງ',
  'How to reach you from the airport or bus station, landmarks and parking.':
    'ວິທີມາຫາທ່ານຈາກສະໜາມບິນ ຫຼື ສະຖານີລົດ, ຈຸດສັງເກດ ແລະ ບ່ອນຈອດລົດ.',
  Airport: 'ສະໜາມບິນ',
  'Train or bus station': 'ສະຖານີລົດໄຟ ຫຼື ລົດເມ',
  Attraction: 'ສະຖານທີ່ທ່ອງທ່ຽວ',
  Shopping: 'ແຫຼ່ງຊື້ເຄື່ອງ',
  Hospital: 'ໂຮງໝໍ',

  // Guest booking page
  About: 'ກ່ຽວກັບ',
  'Read more': 'ອ່ານເພີ່ມ',
  'Show less': 'ສະແດງໜ້ອຍລົງ',
  more: 'ເພີ່ມເຕີມ',
  'View photos': 'ເບິ່ງຮູບ',
  'Previous photo': 'ຮູບກ່ອນໜ້າ',
  'Next photo': 'ຮູບຕໍ່ໄປ',
  Built: 'ສ້າງປີ',
  Renovated: 'ປັບປຸງປີ',
  'Staff speak': 'ພະນັກງານເວົ້າ',
  'Show all facilities': 'ສະແດງສິ່ງອຳນວຍຄວາມສະດວກທັງໝົດ',
  until: 'ຮອດ',
  Until: 'ກ່ອນ',
  'Children under': 'ເດັກອາຍຸຕ່ຳກວ່າ',
  'stay free using existing beds.': 'ປີ ພັກຟຣີ ໂດຍໃຊ້ຕຽງທີ່ມີຢູ່.',
  'Children are welcome.': 'ຍິນດີຕ້ອນຮັບເດັກນ້ອຍ.',
  'Children are not allowed.': 'ບໍ່ອະນຸຍາດເດັກນ້ອຍ.',
  'Cribs available on request': 'ມີຕຽງເດັກອ່ອນຕາມການຮ້ອງຂໍ',
  'Pets are allowed.': 'ອະນຸຍາດສັດລ້ຽງ.',
  'Pets are allowed on request.': 'ອະນຸຍາດສັດລ້ຽງຕາມການຮ້ອງຂໍ.',
  'Pets are not allowed.': 'ບໍ່ອະນຸຍາດສັດລ້ຽງ.',
  'Smoking is allowed.': 'ອະນຸຍາດໃຫ້ສູບຢາ.',
  'Smoking only in designated areas.': 'ສູບຢາໄດ້ສະເພາະພື້ນທີ່ທີ່ກຳນົດ.',
  'This is a non-smoking property.': 'ທີ່ພັກນີ້ປອດຢາສູບ.',
  'Smoking allowed': 'ສູບຢາໄດ້',
  'A passport or ID card is required at check-in.':
    'ຕ້ອງສະແດງໜັງສືຜ່ານແດນ ຫຼື ບັດປະຈຳຕົວຕອນເຊັກອິນ.',
};
